export default "__VITE_ASSET__e2f14601__"